import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from 'src/environments/environment';
import { UserFinance } from "../_models/userFinance";
import { ItemFinance } from "../_models/itemFinance";
import { DocumentNumbering } from "../_models/documentNumbering";
import { BehaviorSubject } from "rxjs/internal/BehaviorSubject";
import { AccountItem } from "../_models/accountItems";
import { Account } from "../_models/account";
import { Exchangerate } from "../_models/exchangerate";
import { Invoices } from "../_models/invoices";
import { AccountStatement } from "../_models/accountStatemet";
import { BankStatementItem } from "../_models/bankStatementItem";
import { Observable } from "rxjs";
import { GenetarePdfForm } from "../_models/generatePdfForm";
import { FinancialAccount } from "../_models/financial-account";



@Injectable({
    providedIn: `root`
})

export class FinanceService {
    
    baseUrl = environment.apiUrl;
    private itemData = new BehaviorSubject<any[]>([]);
    currentData = this.itemData.asObservable();
    private dateData = new BehaviorSubject<any[]>([]);
    currentDataDate =  this.dateData.asObservable();
    private datePrices = new BehaviorSubject<any[]>([]);
    currentDataPrices =  this.datePrices.asObservable();
   


    private invoiceSubject = new BehaviorSubject<any>({});
    invoiceData =this.invoiceSubject.asObservable();

    private invoiceIdSubject = new BehaviorSubject<any>(null);
    invoiceId =this.invoiceIdSubject.asObservable();

    constructor(private http: HttpClient) {}

    sendInvoiceID(id: number,print: boolean) {
        this.invoiceIdSubject.next({id: id, print: print});
   
    }
    sendInvoiceToDisplay(account: any) {
        this.invoiceSubject.next(account);
   
    }



    addUser(user: UserFinance) {
       
        return this.http.post(this.baseUrl + 'finance/add', user);
       
      }
    addItem(item:ItemFinance) {
        
        return this.http.post(this.baseUrl + 'finance/addItem', item);
       
    }
    getNextPassword(){
        return this.http.get(this.baseUrl + 'finance/nextPassword');
    }
    getAllClients(){
        return this.http.get<UserFinance[]>(this.baseUrl + 'finance/bussines-client');
    }
    getAllItems(){
        return this.http.get<ItemFinance[]>(this.baseUrl + 'finance/bussines-item');
    }
    deleteClientFinanceById(id:number){
        return this.http.delete<UserFinance>(this.baseUrl + `finance/${id}`);
    }
    deleteItemById(id:number){
        return this.http.delete<ItemFinance>(this.baseUrl + `finance/item/${id}`);
    }
    getClientFinance(id:number){
        return this.http.get<UserFinance>(this.baseUrl + `finance/client-finance/${id}`);
    }
    getItemFinance(id:number){
        return this.http.get<ItemFinance>(this.baseUrl + `finance/item-finance/${id}`);
    }
    editUser(user: UserFinance,id:number) {
        
        return this.http.put<UserFinance>(this.baseUrl + `finance/edit/${id}`, user);   
      }
    editItem(item: ItemFinance,id:number) {
        
        return this.http.put<ItemFinance>(this.baseUrl + `finance/edit-item/${id}`, item);   
      }
    editDocument(document: DocumentNumbering,id:number) {
        
        return this.http.put<DocumentNumbering>(this.baseUrl + `finance/edit-document/${id}`, document);   
      }
    addDocument(document:DocumentNumbering) {

        return this.http.post<DocumentNumbering>(this.baseUrl + 'finance/addDocument', document);   
    }
    addAccount(account:Account){
        return this.http.post<number>(this.baseUrl + 'finance/addAccountItem', account);
    }

    getNextPasswordDocumentation(){
        return this.http.get(this.baseUrl + 'finance/nextPasswordDocument');
    }
    getAllDocuments(){
        return this.http.get<DocumentNumbering[]>(this.baseUrl + 'finance/all-documents');
    }
    deleteDocumentById(id:number){
        return this.http.delete<DocumentNumbering>(this.baseUrl + `finance/delete-document/${id}`);
    }
    getDocument(id:number){
        return this.http.get<DocumentNumbering>(this.baseUrl + `finance/document/${id}`);
    }
    sendItem(data: any[]) {
        this.itemData.next(data);
   
      }
    sendDate(data: any[]) {
        this.dateData.next(data);
      }
    sendPrices(data: any[]) {
        this.datePrices.next(data);
       
      }
    deleteAccount(itemId:number){
        return this.http.delete(this.baseUrl + `finance/deleteAccount/${itemId}`);
    }
    addExchangeRate(ex:Exchangerate){
        return this.http.post<Exchangerate>(this.baseUrl + 'finance/addExchangerate', ex);
    }
    getAllExchangerate(){
        return this.http.get<Exchangerate[]>(this.baseUrl + 'finance/all-exchangerate');
    }
    getAllAccounts(){
        return this.http.get<Invoices[]>(this.baseUrl + 'finance/all-accounts');
    }
    
    getClientsListForGpsClients(){
        return this.http.get<ItemFinance[]>(this.baseUrl + 'finance/bussines-client-for-gps-clients');
    }
    getClientsByPib(pib:string){
        return this.http.get<UserFinance>(this.baseUrl + `finance/get-bussines-client-by-pib/${pib}`);
    }
    exportExcelById(id: number) {
        return this.http.get<any>(this.baseUrl + `finance/exportExcel/${id}`);
    }
    exportAccountsExcel(object:any) {
        return this.http.post<any>(this.baseUrl + `finance/exportAccountsExcel`,object);
    }   
    // getAllItemsByAccountId(customerId:number,accountId:number){
    //     return this.http.get<AccountItem>(this.baseUrl + `finance/items/${customerId}/${accountId}`);
    // }
    createGeneratePdfForm(pdfForm:any){
        return this.http.post<any>(this.baseUrl + 'finance/addGeneratePdfForm',pdfForm);
    }
    getGeneratePdf(){
        return this.http.get<GenetarePdfForm>(this.baseUrl + 'finance/generatePdfForm');
    }
    exportClientsExcel(object:any) {
        return this.http.post<any>(this.baseUrl + `finance/exportClientsExcel`,object);
    } 
    getTaxRates(){
        return this.http.get<any>(this.baseUrl + `finance/taxRates`);
    }  
    getInvoiceTypes(){
        return this.http.get<any>(this.baseUrl + `finance/invoice-type-info`);
    }  
    getInvoicePeriodCodesInfo(){
        return this.http.get<any>(this.baseUrl + `finance/invoice-period-codes-info`);
    }  
    getTaxCodesBasis(){
        return this.http.get<any>(this.baseUrl + `finance/tax-codes-basis`);
    } 
    addFinancialAccounts(financialAccounts:FinancialAccount[]) {
        return this.http.post(this.baseUrl + 'finance/addEditFinancialAccounts', financialAccounts);
    } 
    getFinancialAccounts() {
        return this.http.get(this.baseUrl + 'finance/getFinancialAccounts');
    } 
    getInvoiceDataByAccountId(invoiceId:number){
        return this.http.get<any>(this.baseUrl + `finance/invoiceData/${invoiceId}`);
    }
    getInvoiceDataForEditByAccountId(invoiceId:number){
        return this.http.get<AccountItem>(this.baseUrl + `finance/getInvoiceDataForEdit/${invoiceId}`);
    }
    editInvoice(account:Account,invoiceId:number){
        return this.http.post<number>(this.baseUrl + `finance/editInvoicData/${invoiceId}`, account);
    }
    sendInvoiceToEInvoiceAPI(invoiceId:number){
        return this.http.get<any>(this.baseUrl + `finance/sendInvoiceToApi/${invoiceId}`);
    }
    getInvoiceDocumentReference(){
        return this.http.get<AccountItem>(this.baseUrl + `finance/invoice-document-reference`);
    }
    addNewFile(xmldata: FormData) {  
        return this.http.post(this.baseUrl + 'finance/addNewFile', xmldata);  
    }
    getAllBankStatement(){
        return this.http.get<AccountStatement[]>(this.baseUrl + 'finance/all-bank-statement');
    }
    getAllBankStatementItem(){
        return this.http.get<BankStatementItem[]>(this.baseUrl + 'finance/all-bank-statement-item');
    }
    getBankStatementItem(){
        return this.http.get<AccountStatement[]>(this.baseUrl + 'finance/bank-statement');
    }
    addNewFileTxt(xmldata: FormData) {  
        return this.http.post(this.baseUrl + 'finance/addNewFileTxt', xmldata);  
    }


    sendInvoiceToEmail(invoiceId:number){
        return this.http.get<any>(this.baseUrl + `finance/sendInvoiceToEmail/${invoiceId}`);
    }
}